/**
 * Validações de documentos brasileiros.
 *
 * Ficam na fronteira de confiança: motorista digita, a plataforma
 * responde por ele. CPF com dígito errado é typo ou fraude — nos dois
 * casos não entra no banco.
 */

/** Aceita com ou sem pontuação. Valida os dois dígitos verificadores. */
export function isValidCPF(input: string): boolean {
  const cpf = input.replace(/\D/g, '');
  if (cpf.length !== 11) return false;

  // 00000000000, 11111111111... passam no cálculo mas não existem.
  if (/^(\d)\1{10}$/.test(cpf)) return false;

  for (const [len, factor] of [
    [9, 10],
    [10, 11],
  ] as const) {
    let sum = 0;
    for (let i = 0; i < len; i++) {
      sum += Number(cpf[i]) * (factor - i);
    }
    const rest = (sum * 10) % 11;
    const digit = rest === 10 ? 0 : rest;
    if (digit !== Number(cpf[len])) return false;
  }
  return true;
}

export function formatCPF(input: string): string {
  const cpf = input.replace(/\D/g, '');
  return cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
}

/** Placa antiga (AAA0000) ou Mercosul (AAA0A00). */
export function isValidPlate(input: string): boolean {
  const plate = input.replace(/[\s-]/g, '').toUpperCase();
  return /^[A-Z]{3}\d{4}$/.test(plate) || /^[A-Z]{3}\d[A-Z]\d{2}$/.test(plate);
}

export function normalizePlate(input: string): string {
  return input.replace(/[\s-]/g, '').toUpperCase();
}
